/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  REVOKE_CREDENTIAL: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.revoke.credential',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'REVOKE_CREDENTIAL' },
      },
    },
    REVOKE_CREDENTIAL: {
      invoke: {
        id: 'revokeCredential',
        src: 'revokeCredential',
        onDone: {
          target: 'REVOKE_CREDENTIAL_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'REVOKE_CREDENTIAL_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    REVOKE_CREDENTIAL_SUCCESS: {
      type: 'final',
    },
    REVOKE_CREDENTIAL_ERROR: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
